import useChat from '@/hooks/useChat'
import useChatCable from '@/hooks/useChatCable'
import getAppConfig from '@/utils/getAppConfig'

const useChatTransport = getAppConfig().chatTransport === 'sse' ? useChat : useChatCable

export default useChatTransport
